import React from 'react';
import "./git.css";

function GetInTouch() {
  return (
    <div className='gitint-containeer'>
      <div className='gitint'>
        <div className='extra'>
          <h2 className='sth2'>Healing begins the moment you walk into Shri Adithya Hospitals</h2>
          <h2>Every life we touch is a story we’re honoured to be part of</h2>
          <button>Get In Touch</button>
        </div>
      </div>
    </div>
  );
}

export default GetInTouch;
